import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiDownload, FiCalendar } from "react-icons/fi";

export default function FinancialHealth() {
  const [filter, setFilter] = useState("Yearly");
  const [hoverIndex, setHoverIndex] = useState(null);

  const dataMap = {
    Today: [20, 30, 25, 35, 28],
    Weekly: [30, 50, 40, 60, 45, 55, 35],
    Monthly: [20, 40, 30, 50, 60, 45, 35, 55],
    Yearly: [25, 45, 20, 35, 70, 90, 60, 30, 50, 65],
  };

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
  ];

  return (
    <>
      <style>{`
        .card-ui {
          border-radius: 5px;
          border: 2px solid #e6e6e6;
          background: #fff;
          padding: 14px;
        }

        .title {
          font-weight: 700;
          text-decoration: underline;
          font-size: 15px;
        }

        /* DROPDOWN FIX */
        .date-btn,
        .date-btn:focus,
        .date-btn:active,
        .show > .date-btn.dropdown-toggle {
          background-color: #fff !important;
          color: #333 !important;
          border: 1px solid #e5e7eb !important;
          box-shadow: none !important;
        }

        .dropdown-menu {
          background-color: #fff !important;
          border-radius: 10px;
          border: 1px solid #eee;
        }

        .dropdown-menu .dropdown-item:hover {
          background-color: #ff7a2f !important;
          color: #fff !important;
        }

        .icon-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: none;
          background: #f1f5f9;
        }

        /* MAIN LAYOUT */
        .main-row {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px;
        }

        /* GRAPH */
        .graph-wrap {
          display: flex;
          align-items: flex-end;
          gap: 14px;
          height: 170px;
          flex: 1 1 0;
          min-width: 0;
          overflow: hidden;
        }

        .bar {
          position: relative;
          cursor: pointer;
        }

        /* BARS */
        .bar-bg {
          width: 34px;
          border-radius: 20px;
        background: linear-gradient(to top, #f3f3f3, #b9cdd2);
          box-shadow:
            inset 0 2px 6px rgba(255,255,255,0.5),
            inset 0 -6px 12px rgba(0,0,0,0.05);
          position: relative;
        }

        .bar-bg::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 10%;
          width: 80%;
          height: 22px;
          background: rgba(0,0,0,0.08);
          filter: blur(10px);
          border-radius: 50%;
        }

        .bar-active {
          width: 34px;
          border-radius: 20px;
          background: linear-gradient(to top,#ff6b1a,#ff8a3d);
          box-shadow:
            inset 0 2px 4px rgba(255,255,255,0.5),
            0 10px 20px rgba(255,107,26,0.35);
          position: relative;
          z-index: 2;
        }

        .bar-active::after {
          content: "";
          position: absolute;
          bottom: -12px;
          left: 10%;
          width: 80%;
          height: 18px;
          background: rgba(255,107,26,0.25);
          filter: blur(12px);
          border-radius: 50%;
        }

        /* TOOLTIP */
        .tooltip-ui {
          position: absolute;
          top: -65px;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          padding: 8px 12px;
          border-radius: 10px;
          font-size: 12px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          white-space: nowrap;
        }

        .dot {
          width: 8px;
          height: 8px;
          background: #ff6b1a;
          border-radius: 50%;
          display: inline-block;
          margin-right: 6px;
        }

        /* RIGHT */
        .right {
          margin-left: 25px;
          text-align: right;
          flex: 0 0 auto;
          min-width: 180px;
        }

        .amount {
          font-size: 28px;
          font-weight: 700;
          margin: 0;
        }

        .growth {
          background: #16a34a;
          color: #fff;
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
        }

        /* 🔥 MOBILE FIX (ONLY CHANGE) */
        @media (max-width: 768px) {

          .card-ui .d-flex.justify-content-between {
            flex-direction: column;
            align-items: flex-start !important;
            gap: 10px;
          }

          .main-row {
            flex-direction: column;
            align-items: stretch;
          }

          .graph-wrap {
            width: 100%;
            overflow-x: auto;
            gap: 10px;
            height: 140px;
            padding-bottom: 10px;
          }

          .bar-bg,
          .bar-active {
            width: 22px !important;
          }

          .tooltip-ui {
            top: -55px;
            font-size: 11px;
          }

          .right {
            text-align: left;
            margin-left: 0;
            margin-top: 12px;
          }

          .amount {
            font-size: 22px;
          }

          .right .d-flex {
            justify-content: flex-start !important;
          }
        }
      `}</style>

      <Card className="card-ui h-100">
        <Card.Body>
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center gap-2">
              <h4 className="title mb-0">Financial Health</h4>

              <Dropdown>
                <Dropdown.Toggle className="date-btn text-dark">
                  <FiCalendar className="me-1" />
                  {filter}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {Object.keys(dataMap).map((item) => (
                    <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <button className="icon-btn">
              <FiDownload />
            </button>
          </div>

          {/* BODY */}
          <div className="main-row">
            <div className="graph-wrap">
              {dataMap[filter].map((val, i) => {
                const isActive = hoverIndex === i;

                return (
                  <div
                    key={i}
                    className="bar"
                    onMouseEnter={() => setHoverIndex(i)}
                    onMouseLeave={() => setHoverIndex(null)}
                  >
                    <div
                      className={isActive ? "bar-active" : "bar-bg"}
                      style={{ height: val + 40 }}
                    >
                      {isActive && (
                        <div className="tooltip-ui">
                          <div>{labels[i]}</div>
                          <div>
                            <span className="dot"></span>
                            Amount: <b>{val}</b>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="right">
              <div style={{ fontSize: "13px", color: "#64748b" }}>
                Total Amount
              </div>
              <p className="amount">$4,56,545</p>

              <div className="d-flex align-items-center justify-content-end gap-2">
                <span className="growth">↗ 2.5%</span>
                <span style={{ fontSize: "12px", color: "#64748b" }}>
                  vs Last Year
                </span>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}
